export default __webpack_public_path__ + "static/media/no-result.a4c3ac4f.svg";